import styled from '@emotion/styled';
import arrowDown from '../assets/images/arrow-down-grey-solid.svg';
import {
  appTextColor,
  lightGrey,
  focusedInputBorderColor,
  mediumGrey,
  menuHilitedColor,
  menuSelectedColor,
  white
} from './colors';

const _buttonTopPadding = 9;
const _buttonSidePadding = 16;
const _buttonTextToArrowSpace = 9;
const _fontSize = 14;
const _itemHeight = 28;
const _itemStartPad = 20;
const _arrowWidth = 15;
const _menuVertPad = 5;
const _listMaxHeight = 238;

export const menuStyle = {
  menuTopPad: _menuVertPad,
  itemHeight: _itemHeight,
  animateMenu: false,
  listMaxHeight: _listMaxHeight,
  buttonBorderWidth: 1,
  listBorderWidth: 1,

  RSDropdownDiv: styled.div(() => {
    let style = {
      position: 'relative',
      width: '100%',
      height: '100%',
      outline: 'none',
      border: '1px solid ' + lightGrey,
      ':active:hover': {
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.125)'
      },
      borderRadius: '3px',
      backgroundColor: white,
      ':focus': {
        borderColor: focusedInputBorderColor
      }
    };
    return style;
  }),

  MenuButton: styled.div(() => {
    let style = {
      cursor: 'pointer',
      textAlign: 'left',
      width: '100%',
      height: '100%'
    };
    return style;
  }),

  MenuButtonLabel: styled.div((props) => {
    let style = {
      position: 'absolute',
      top: 2 + _buttonTopPadding,
      height: '100%',
      color: appTextColor,
      fontSize: _fontSize,
      lineHeight: _fontSize * 1.25 + 'px',
      fontWeight: '400',
      letterSpacing: '0.7px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    };
    if (props.isRtl) {
      style.right = _buttonSidePadding;
      style.left = _arrowWidth + _buttonSidePadding + _buttonTextToArrowSpace;
    } else {
      style.left = _buttonSidePadding;
      style.right = _arrowWidth + _buttonSidePadding + _buttonTextToArrowSpace;
    }
    return style;
  }),

  MenuButtonArrow: styled.div((props) => {
    let style = {
      position: 'absolute',
      backgroundImage: 'url(' + arrowDown + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      top: 2 + _buttonTopPadding,
      width: _arrowWidth,
      height: _arrowWidth
    };
    if (props.isRtl) {
      style.left = _buttonSidePadding;
    } else {
      style.right = _buttonSidePadding;
    }
    return style;
  }),

  MenuList: styled.ul((props) => {
    let style = {
      position: 'absolute',
      top: props.listTop,
      left: '0px',
      right: '0px',
      backgroundClip: 'padding-box',
      backgroundColor: white,
      borderColor: mediumGrey,
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: '0px',
      boxShadow: '0 6px 12px rgba(0,0,0,.175)',
      listStyle: 'none',
      margin: 0,
      paddingTop: _menuVertPad,
      paddingBottom: _menuVertPad,
      paddingLeft: 0,
      maxHeight: _listMaxHeight,
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: '1000'
    };
    return style;
  }),

  MenuItem: styled.li((props) => {
    let style = {
      backgroundColor: white,
      color: appTextColor,
      fontSize: _fontSize,
      fontWeight: 'normal',
      letterSpacing: '0',
      height: _itemHeight,
      paddingTop: 5,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'left'
    };
    if (props.isRtl) {
      style.paddingLeft = 0;
      style.paddingRight = _itemStartPad;
    } else {
      style.paddingLeft = _itemStartPad;
      style.paddingRight = 0;
    }
    if (props.highlight && !props.selected) {
      style.color = appTextColor;
      style.backgroundColor = menuHilitedColor;
    }
    if (props.selected) {
      style.color = white;
      style.cursor = 'default';
      style.backgroundColor = menuSelectedColor;
    }
    return style;
  })
};



// WEBPACK FOOTER //
// ./src/styles/LaunchpadDropdownStyle.js